import { useEffect } from "react";

const DEFAULT_TITLE = "Fussboden Blum - Parkett & Fußbodentechnik aus Kalbach";
const DEFAULT_DESC = "Fussboden Blum aus Kalbach - Erfahrung und Kompetenz rund um Fussböden seit 1969. Wir freuen uns auf Ihren Besuch.";

export const useSeo = (title, description) => {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description || DEFAULT_DESC);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.setAttribute("content", DEFAULT_DESC);
    };
  }, [title, description]);
};
